export const GoogleMapApiConfig = 'AIzaSyAADoAIT59f8LU4wlgm7Ivyt83KJnTeYv8';